import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject, tap } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { BrokerMandateSignaturesRequestModel, BrokerMandateSignaturesResponseModel } from '../../model';

@Injectable({
  providedIn: 'root',
})
export class BrokerMandateSignatureService {
  public mandateDataChangedSubject = new Subject();

  constructor(private http: HttpClient) {}

  public getBrokerMandateSignatures(
    body: BrokerMandateSignaturesRequestModel,
  ): Observable<BrokerMandateSignaturesResponseModel> {
    let params: HttpParams = new HttpParams();

    if (body?.filter_state?.length > 0) {
      body.filter_state.forEach(
        (state: 'PENDING' | 'APPROVED' | 'REJECTED_WRONG_SIGNATURE' | 'REJECTED_WRONG_DATA'): void => {
          params = params.append('filter_state', state);
        },
      );
    }
    if (body?.page) {
      params = params.set('page', body.page);
    }
    if (body?.page_size) {
      params = params.set('page_size', body.page_size);
    }

    return this.http.get<BrokerMandateSignaturesResponseModel>(
      `${environment.apiEndpoint}/account/broker-mandate/signature`,
      { params },
    );
  }

  public reviewBrokerMandateSignature(
    clientId: string,
    outcome: 'APPROVED' | 'WRONG_SIGNATURE' | 'WRONG_DATA',
  ): Observable<void> {
    let params: HttpParams = new HttpParams();

    if (outcome) {
      params = params.set('outcome', outcome);
    }

    return this.http
      .post<void>(`${environment.apiEndpoint}/account/broker-mandate/signature/${clientId}/review`, null, {
        params,
      })
      .pipe(
        tap((): void => {
          if (outcome === 'APPROVED') {
            this.mandateDataChangedSubject.next(true);
          }
        }),
      );
  }

  public invalidateBrokerMandateSignature(clientId: string): Observable<void> {
    return this.http.post<void>(
      `${environment.apiEndpoint}/account/broker-mandate/signature/${clientId}/invalidate`,
      null,
    );
  }

  public generatePreviewPDF(
    clientId: string,
    type: 'BROKER_MANDATE' | 'POWER_OF_ATTORNEY' | 'PRIVACY_CONSENT',
  ): Observable<Blob> {
    return this.http.get(`${environment.apiEndpoint}/account/broker-mandate/signature/${clientId}/pdf/${type}`, {
      responseType: 'blob',
    });
  }

  public chatMessageSignatureRequest(clientId: string): Observable<void> {
    return this.http.post<void>(
      `${environment.apiEndpoint}/account/broker-mandate/signature/${clientId}/chat-request`,
      null,
    );
  }
}
